import React from 'react';
import { useNavigate } from 'react-router-dom';
import UserProfile from '../components/UserProfile';

const UserProfilePage = ({ token, handleLogout }) => {
  const navigate = useNavigate();

  const handleLogoutAndRedirect = () => {
    if (handleLogout) handleLogout();
    navigate('/login');
  };

  if (!token) {
    navigate('/login');
    return null;
  }

  return <UserProfile token={token} handleLogout={handleLogoutAndRedirect} />;
};

export default UserProfilePage;